import React, { useMemo } from 'react';
import BlockGrid from 'components/BlockGrid';
import imageImport from 'images';
import withTheme from '@mui/styles/withTheme';
import PageTitle from 'studio/components/PageTitle';

const ChooseDataSource = ({ connectors, selectConnector, alerts, theme }) => {
  const isDarkMode = useMemo(() => theme.isDark, [theme]);

  const formattedConnectors = useMemo(() => {
    if (connectors) {
      return connectors.map(data => ({
        id: data.id,
        name: data.name,
        image: imageImport(data.id, isDarkMode),
        onClick: () => selectConnector(data)
      }));
    }
    return [];
  }, [connectors, isDarkMode, selectConnector]);

  return (
    <>
      <PageTitle>1 - Choose Data Source</PageTitle>
      {alerts}
      <BlockGrid items={formattedConnectors} loading={!formattedConnectors.length} data-test="dataSourceSelector" />
    </>
  );
};

export default withTheme(ChooseDataSource);
